import React from 'react';
import { Container, Row, Col, Spacer, Card, Badge, Image, Divider } from '@cleartrip/bento';

import Header from 'components/composite/Header';
import Footer from 'components/composite/Footer';
import SideNav from 'components/about/SideNav'
import { Train } from '@cleartrip/bento-icons'
import { Hotels } from '@cleartrip/bento-icons'
import { Flights } from '@cleartrip/bento-icons'

import {ReactComponent as Instagram } from 'assets/icons/instagram.svg'
import {ReactComponent as WhatsApp } from 'assets/icons/WhatsApp.svg'
import { ReactComponent as Facebook } from 'assets/icons/facebook.svg';
import { ReactComponent as Linkedin } from 'assets/icons/linkedin.svg';

import Stuart from 'assets/leaders/Stuart.png';
import Amit from 'assets/leaders/Amit.png';
import Sameer from 'assets/leaders/Sameer.png';
import Ismail from 'assets/leaders/Ismail.png';
import Manoj from 'assets/leaders/Manoj.png';
import banner from 'assets/logos/AboutUs-Leadimage.png';

import { RightChevron } from '@cleartrip/bento-icons';

function AboutPage() {
	const additionalTabsContent = (
		<>
			<a className='fw-500 fs-3 td-none c-tertiary-900' href='/about'>
				About
			</a>
			{/* <Spacer className='pr-9' />
			<a className='hover:td-underline fw-500 fs-3 td-none c-secondary-500' target="_blank" href='/jobs'>
				Jobs
			</a> */}
			<Spacer className='pr-9' />
			<a className='hover:td-underline fw-500 fs-3 td-none c-secondary-500 target="_blank"' href='/support'>
				Support
			</a>
			<Spacer className='pr-9' />
			<a href='http://blog.cleartrip.com' className='hover:td-underline fw-500 fs-3 td-none c-secondary-500' target="_blank">
				Blogs
			</a>
		</>
	);
	return (
		<>
			<Header additionalTabs={additionalTabsContent} />
			<main className='flex-1'>
				{/* <Row> */}
				<div className='d-none d-block--xs'>
					<div className='flex px-8 py-2 flex-middle flex-around'>
						<Badge outline={false} size='lg' type='secondary'>
							<span className='tt-capitalize fw-500 fs-3'>About</span>
						</Badge>
						{/* <a href='https://www.cleartrip.com/jobs' className='flex flex-middle flex-between td-none hover:td-underline'>
							<span className='lh-copy fs-3 c-secondary-500 fw-500'>Jobs</span>
						</a> */}
						<a href='http://www.cleartrip.com/support' className='flex flex-middle flex-between td-none hover:td-underline'>
							<span className='lh-copy fs-3 c-secondary-500 fw-500'>Support</span>
						</a>
						<a href='' className='flex flex-middle flex-between td-none hover:td-underline'>
							<span className='lh-copy fs-3 c-secondary-500 fw-500'>Blog</span>
						</a>
					</div>
					<Divider className='mb-2' />
				</div>
				{/* </Row> */}

				<Container>
					<Row>
						<Col span={5} xs={24}>
							<SideNav active="about" />
						</Col>
						<Col span={19} xs={24}>
							<Spacer className='pt-15 pt-10--xs' />
							<h1 className='fs-heading-3 c-neutral-900 fw-700'>Travel planning at your fingertips</h1>
							<Spacer className='pt-8' />
							<div style={{ width: '100%' }}>
								<img src={banner} width="100%"
									style={{ maxWidth: '100%' }} />
							</div>
							<Spacer className='pt-8' />

							<Row>
								<Col span={12} xs={24}>
									<p className="c-neutral-900 fs-7 pb-4 lh-copy">Keeping it simple</p>
									<p className="c-neutral-700 fs-3 pb-4 lh-copy">
										Each day, we come together with a shared commitment to delivering the most comprehensive travel experience available. Our award-winning mobile and desktop solutions are crafted with user convenience in mind, offering a vast selection of flights and hotels to cater to diverse travel needs. Through continuous innovation and enhancement of our intuitive products, we ensure users have access to the best options and seamless booking experiences.
										<br/>
										<br/>
										By keeping our customers at the heart of everything we do, we strive to make every journey as smooth and enjoyable as possible. Our dedication transforms travel dreams into reality, ensuring that each trip is memorable and hassle-free.
									</p>
									<div className="flex">
										<div className="c-secondary-600 pr-3">
											<Flights height={40} width={40} />
										</div>
										<div className="c-secondary-600 pr-3">
											<Hotels height={40} width={40} />
										</div>
										{/* <div className="c-secondary-600 pr-3">
                                    <Train height={40} width={40}/>
                                </div> */}

									</div>
									<Spacer className='pt-8' />

									<p><a title="See Life at Cleartrip" href="">Come work with us →</a></p>
									<Spacer className="pt-10--xs" />
								</Col>

								<Col span={12} xs={24}>
									<p className="c-neutral-900 fs-7 pb-4 lh-copy">Behind the screens</p>
									<p className="c-neutral-700 fs-3 pb-4 lh-copy">
									Our leadership team is a diverse and dynamic group, guided by the values we hold dear. 
									Their ongoing mission is to continuously innovate and deliver a best-in-class customer experience.
									</p>
									<div className="flex">
										<div style={{display:'flex',flexDirection:'column'}}>
											<img src={Stuart} width="100px" />
											<p style={{fontSize:'12px',textAlign:'center'}}>Stuart Crighton</p>
										</div>
										<Spacer className="pl-2" />
										<div style={{display:'flex',flexDirection:'column'}}>
											<img src={Amit} width="100px" />
											<p style={{fontSize:'12px',textAlign:'center'}}>Amit Taneja</p>
										</div>
										<Spacer className="pl-2" />
										<div style={{display:'flex',flexDirection:'column'}}>
											<img src={Sameer} width="100px" />
											<p style={{fontSize:'12px',textAlign:'center'}}>Sameer Bagul</p>
										</div>
										<Spacer className="pl-2" />
										<div style={{display:'flex',flexDirection:'column'}}>
											<img src={Manoj} width="100px" />
											<p style={{fontSize:'12px',textAlign:'center'}}>Manoj Sharma</p>
										</div>
									</div>
								</Col>
							</Row>
							<Spacer className='pt-15 pt-10--xs' />
							<Divider className='bc-neutral-100' />
							<Spacer className='pt-15 pt-10--xs' />

							<p className="c-neutral-900 fs-7 pb-4 lh-copy"> At your service. Anywhere. Anytime</p>
							<Row>
								<Col xs={24}>
									<a
										target='_blank'
										href='https://www.facebook.com/CleartripArabia/'
										className='td-none hover:bg-neutral-0 c-pointer px-4 py-3 br-4 ba bc-neutral-100 flex flex-middle'
									>
										<div>
											<Facebook height={36} width={36} className='br-100 c-neutral-400' />
										</div>
										<Spacer className='pl-4' />
										<p className='fs-4 fw-400 c-secondary-500'>Connect with us on Facebook</p>
									</a>
								</Col>

								<Col xs={24}>
									<Spacer className='pt-4--xs' />
									<a
										target='_blank'
										href='https://www.instagram.com/cleartrip_arabia/'
										className='hover:bg-neutral-0 td-none px-4 py-3 br-4 ba bc-neutral-100 flex flex-middle'
									>
										<div>
											<Instagram height={36} width={36} className='br-100 c-neutral-400' />
										</div>
										<Spacer className='pl-4' />
										<p className='fs-4 fw-400 c-secondary-500 d-block--xs d-none'>Follow us on Instagram</p>
										<p className='fs-4 fw-400 c-secondary-500 d-none--xs'>
											Follow us on <br />
											Instagram
										</p>
									</a>
								</Col>

								<Col xs={24}>
									<Spacer className='pt-4--xs' />
									<a
										target='_blank'
										href='https://www.linkedin.com/company/cleartrip-arabia'
										className='hover:bg-neutral-0 td-none px-4 py-3 br-4 ba bc-neutral-100 flex flex-middle'
									>
										<div>
											<Linkedin height={36} width={36} className='br-100 c-neutral-400' />
										</div>
										<Spacer className='pl-4' />
										<p className='fs-4 fw-400 c-secondary-500 d-none--xs'>
											Stay connected<br />
											on LinkedIn
										</p>
										<p className='fs-4 fw-400 c-secondary-500 d-none d-block--xs'>Stay connected on LinkedIn</p>
									</a>
								</Col>
								<Col xs={24}>
									<Spacer className='pt-4--xs' />
									<a
										target='_blank'
										href='https://wa.me/+971502672234'
										className='hover:bg-neutral-0 td-none px-4 py-3 br-4 ba bc-neutral-100 flex flex-middle'
									>
										<div>
											<WhatsApp height={36} width={36} className='br-100 c-neutral-400' />
										</div>
										<Spacer className='pl-4' />
										<p className='fs-4 fw-400 c-secondary-500 d-none--xs'>
										Have a chat on<br/>
										WhatsApp
										</p>
										<p className='fs-4 fw-400 c-secondary-500 d-none d-block--xs'>Stay connected on LinkedIn</p>
									</a>
								</Col>
							</Row>
							<Spacer className='pt-8' />

							<p className="c-neutral-700 fs-3 pb-4 lh-copy">We’re never too far away from you.
								Give us a shout for any assistance on new bookings, cancellations or amendments,
								and we’ll spring into action immediately, because we are wherever you are.</p>

							<p><a href="/contact">Contact Us →</a></p>
							<Spacer className='pt-15 pt-10--xs' />

						</Col>
					</Row>
				</Container>
				<Spacer className='pt-15' />
			</main>
			<Footer />
		</>
	);
}

export default AboutPage;
